import React from 'react';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import AdapterLink from 'components/AdapterLink';
import LocaleButton from 'components/LocaleButton';
import LogoSymbol from 'components/Icons/LogoSymbol';
import Hidden from '@material-ui/core/Hidden';
import Tab from 'components/Icons/Tab';
import LogoWithName from 'components/Icons/LogoWithName';
import commonMessages from 'messages/common';
import useCurrentUser from 'hooks/useCurrentUser';
import LoginAvatar from './LoginAvatar';
import ElevationScroll from './ElevationScroll';

const useStyles = makeStyles(theme => ({
  title: {
    flexGrow: 1
  },
  toolbar: {
    [theme.breakpoints.down('xs')]: {
      paddingRight: theme.spacing(1)
    }
  },
  homeLink: {
    display: 'flex',
    alignItems: 'center'
  },
  logo: {
    marginRight: theme.spacing(1),
    width: 45,
    height: 'auto',
    '& path': {
      fill: 'white'
    }
  },
  logoWithName: {
    width: 'auto',
    height: 50,
    color: 'black'
  },
  tabLogo: {
    color: 'white',
    width: 64,
    height: 'auto'
  },
  button: {
    marginRight: theme.spacing(2)
  },
  avatar: {
    backgroundColor: theme.palette.primary.main
  },
  breadcrumbs: {
    flexGrow: 1,
    overflow: 'hidden',
    color: 'white',
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(28),
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(16)
    }
  },
  ol: {
    flexWrap: 'nowrap'
  },
  li: {
    display: 'flex',
    overflow: 'hidden'
  }
}));

interface HeaderProps {
  breadcrumbs?: any;
  color?: 'primary' | 'inherit';
}

const Header: React.FC<HeaderProps> = ({
  color = 'primary',
  breadcrumbs = null
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const { currentUser, loading } = useCurrentUser();
  let leftButtons = null;

  if (currentUser) {
    leftButtons = <LoginAvatar currentUser={currentUser} />;
  } else if (!loading) {
    // leftButtons = (
    //   <Button color="inherit" component={AdapterLink} to="/signin">
    //     {intl.formatMessage(commonMessages.signin)}
    //   </Button>
    // );
  }
  return (
    <ElevationScroll>
      <AppBar elevation={0} color={color} position="sticky">
        <Toolbar
          className={classes.toolbar}
          component={props => <Container maxWidth="lg" {...props} />}
        >
          <Breadcrumbs
            className={classes.breadcrumbs}
            classes={{
              ol: classes.ol,
              // @ts-ignore
              li: classes.li
            }}
            aria-label="Breadcrumb"
          >
            <Link to="/" className={classes.homeLink}>
              {color === 'primary' ? (
                <>
                  <LogoSymbol className={classes.logo} />
                  <Hidden smDown>
                    <Tab className={classes.tabLogo} />
                  </Hidden>
                </>
              ) : (
                <LogoWithName className={classes.logoWithName} />
              )}
            </Link>
            {breadcrumbs}
          </Breadcrumbs>
          <Hidden smDown>
            <LocaleButton color="inherit" className={classes.button} />
          </Hidden>

          {leftButtons}
        </Toolbar>
      </AppBar>
    </ElevationScroll>
  );
};
export default Header;
